import { useMemo } from "react";
import type {
  Address,
  CustomerInformation,
  UserContact,
  Subscription,
} from "../features/common/types";

export const useCustomerCompanyData = (
  customer: CustomerInformation | null
) => {
  const companyContact = useMemo(
    () =>
      customer?.customerContacts?.find(
        (c) => c.contact?.contact_type === "company"
      ),
    [customer]
  );
  const companyAddress: Address | undefined =
    companyContact?.contact?.addresses?.[0];
  const contacts: UserContact[] = customer?.customerContacts ?? [];
  const subscriptions: Subscription[] = customer?.subscriptions ?? [];
  return { companyAddress, contacts, subscriptions } as const;
};
